import { Injectable, EventEmitter } from '@angular/core';
import { BymeService } from './byme.service';
import { CONTEXT } from '../enum/context';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public context: string;
  public initContext: string;
  public userDatas: any;

  public events: EventEmitter<any>;
  public byMeServiceRef: BymeService;

  constructor() {
    this.events = new EventEmitter();
  }

  get isLogged(): boolean {
    return !!this.userDatas;
  }

  get country(): string {
    if (!this.isLogged) return "";
    return this.userDatas.country;
  }

  get applicationId(): number {
    switch (this.context) {
      case CONTEXT.KITCHEN: return 2;
      case CONTEXT.STORAGE: return 2;
      case CONTEXT.BATHROOM: return 7;
      default: return -1;
    }
  }

  resetPhone() {
    if (this.userDatas) {
      this.userDatas.phone = null;
      if (this.userDatas.otherAccount) {
        this.userDatas.otherAccount.entryPhone = null;
      }
    }
  }

  logout() {
    this.events.emit("CUSTOMER_LOGOUT");
    this.userDatas = null;
  }
}
